import { EndpointRequest } from "../../_system/EndpointRequest";
import {
  ReadPackagesRequestDto as RequestDto,
  ReadPackagesResponseDto as ResponseDto,
} from "../../api/packages/list/dtos";
import { Package } from "../../models";
import { PagingMeta } from "../../models/_system";
import { Api } from "../../api";
import format from "date-fns/format";

interface CallParams {
  isLoadMore?: boolean;
  _query: {
    location_id: number;
    person_types: { id: number; quantity: number; name: string }[];
    dates: Date[];
    page?: number | null;
    // per_page?: number;
    lang?: string;
    search?: string;
  };
}
interface Data {
  data: Package[];
  meta: PagingMeta;
}
export const list = new EndpointRequest<
  RequestDto,
  ResponseDto,
  Data,
  CallParams
>(
  "LIST_PACKAGES",
  Api.packages.list,
  ({ data: { data, meta } }, { isLoadMore }, prevState) => {
    if (isLoadMore) {
      return {
        data: [
          ...(prevState.data?.data ?? []),
          ...data.map((i) => new Package(i)),
        ],
        meta: new PagingMeta(meta),
      };
    }
    return {
      data: data.map((i) => new Package(i)),
      meta: new PagingMeta(meta),
    };
  },
  (params) => ({
    ...params,
    _query: {
      ...params._query,
      search: undefined,
      filter: {
        name: params._query.search,
      },
      per_page: 9999, // without pagination
      //person_types is requited parameter
      person_types: params._query.person_types.map(({ id, quantity }) => ({
        person_type_id: id,
        quantity,
      })),
      dates: params._query?.dates.map((date) => format(date, "yyyy-MM-dd")),
    },
  })
);
